module.exports = __webpack_public_path__ + "img/130.784d172e.jpg";